{
  "feedback-internal-success-page": {
    "buttons": {
      "to-salon": "DO SALONU"
    },
    "text": {
      "thanks": "Děkujeme za vaši zpětnou vazbu",
      "thanks-again": "Vaše zpětná vazba je velmi cenná a pomáhá nám zlepšovat naše služby"
    }
  }
}
